import { Navigate } from 'react-router-dom'

import { useHandles } from 'modules/layout/components/ResponsivePage/FactorialOnePage/useResolvedHandles'

const ReroutingIndex = () => {
  const { resolvedHandles, resolving } = useHandles()

  if (!resolving && resolvedHandles?.length > 0) {
    // Grab first visible tab and redirect to it
    const currentHandle = [...resolvedHandles].reverse().find((handle) => handle.meta?.subNavigation)
    const firstVisibleTab = currentHandle?.meta?.subNavigation?.find((item) => item.isVisible)?.href

    if (firstVisibleTab) {
      return <Navigate replace to={firstVisibleTab} />
    }
  }
  return null
}

export default ReroutingIndex
